import DataInfo from './DataInfo';

export default DataInfo;
